import MockAdapter from "axios-mock-adapter";
import { AxiosRequestConfig } from "axios";
import { FILTER_NAMES } from "@/static/filterNames";
import { orderItemsInOrderFilter } from "./responses/orderItemsInOrderFilter";
import { URL_GET_FILTER } from "@/requests/general";
import { orderItemsPreviewFilter } from "./responses/orderItemsPreviewFilter";
import { ordersFilter } from "./responses/ordersFilter";
import { documentsFilter } from "./responses/documentsFilter";
import { bookingsFilter } from "./responses/bookingsFilter";
import costDocumentListStandardFilter from "./responses/costDocumentListStandardFilter";
import { costDocumentImportBookingFilesFilter } from "./responses/costDocumentImportBookingFilesFilter";

export const filtersMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_FILTER).reply((config: AxiosRequestConfig) => {
    const filterName: string = config.params.FilterName;
    let response: unknown = undefined;
    switch (filterName) {
      case FILTER_NAMES.OrderItemsInOrderFilter: {
        response = orderItemsInOrderFilter;
        break;
      }
      case FILTER_NAMES.OrderItemsPreviewFilter: {
        response = orderItemsPreviewFilter;
        break;
      }
      case FILTER_NAMES.OrdersFilter: {
        response = ordersFilter;
        break;
      }
      case FILTER_NAMES.DocumentsFilter: {
        response = documentsFilter;
        break;
      }
      case FILTER_NAMES.BookingsFilter: {
        response = bookingsFilter;
        break;
      }
      case FILTER_NAMES.CostDocumentListStandardFilter: {
        response = costDocumentListStandardFilter;
        break;
      }
      case FILTER_NAMES.CostDocumentImportBookingFiles: {
        response = costDocumentImportBookingFilesFilter;
        break;
      }
      default:
        console.error("unknown filter name");
    }

    if (typeof response === "undefined") {
      return [404];
    }
    return [200, response];
  });
};
